export const triggers = [
  {
    title: 'Test',
    value: 'test',
  },
  {
    title: 'Landing',
    value: 'landing',
  },
  {
    title: 'Exhibit Hall',
    value: 'bpSpotRegionEx01',
  },
].concat(
  Array.from({ length: 10 }, (_, i) => ({
    title: `Exhibit Hall Booth ${i + 1}`,
    value: `bpSpotRegionExB${i + 1 < 10 ? '0' + (i + 1) : i + 1}`,
  })),
);
